module.exports = __webpack_public_path__ + "img/golden-arrows-fc.c2169d8c.png";